const mainfooter = {
  portugues: {
    menu: {
      about: 'Sobre o Bella',
      footerDescription:
        'O Bella da Semana é um portal que deixa você mais próximo do mundo das modelos através de fotografias e vídeos exclusivos, de alta qualidade e bom gosto. Você também encontra colunas sobre temas como saúde, esportes, moda, relacionamentos e erotismo.',
      btnSeeMore: 'Saiba mais',
      freetour: 'Free Tour',
      colums: 'Colunas',
      parceiro: 'Área do parceiro',
      modelos: 'Modelos',
      ecard: 'Ecards',
      edicoes: 'Edições',
      videos: 'Videos',
      lives: 'Lives',
      bellacloud: 'Bella Cloud',
      afiliados: 'Afiliados',
      blog: 'Blog',
      contato: 'Contato',
      imprensa: 'Imprensa',
      news: 'Receba as novidades do Bella',
      news2: 'Cadastre-se e receba a mais deliciosa newsletter da internet',
      newsDescription: '',
      email: 'Insira seu email',
      emailDescription:
        'Ao se cadastrar, você concorda em receber emails da Bella da Semana e aceita nossos termos de uso da web e política de privacidade e cookies.',
      modalSuccessTitle: '',
      errorTitle: '',
      modalErrorDescription: '',
      privacidade: 'Politica de Privacidade',
      cancelamento: 'Politica de Cancelamento',
      copia: '',
      declaracao:
        'O Bella da Semana declara que todas as modelos do site tinham mais de 18 anos de idade no dia em que foram fotografadas. Ao entrar neste site, você jura que é maior de idade em sua área para visualizar material adulto e que deseja visualizá-lo.'
    }
  },
  ingles: {
    menu: {
      about: 'About Us',
      footerDescription:
        'Bella Club is a portal that brings you closer to the world of models through exclusive photos and videos, with high quality and good taste. You will also find columns on topics such as health, sports, fashion, relationships and erotism.',
      btnSeeMore: 'See More',
      freetour: 'Free Tour',
      colums: 'Articles',
      parceiro: 'Partner Area',
      modelos: 'Model',
      ecard: 'Ecards',
      edicoes: 'Editions',
      videos: 'Videos',
      lives: 'Lives',
      bellacloud: 'Bella Cloud',
      afiliados: 'Affiliate Program',
      blog: 'Blog',
      contato: 'Contact',
      imprensa: 'Press',
      news: "Receive Bella's news",
      news2: 'Sign up and get the most delicious newsletter on the internet',
      newsDescription: '',
      email: 'Enter your email',
      emailDescription:
        'By signing up, you agree to receive emails from Bella Club and accept our web terms of use and privacy and cookie policy.',
      modalSuccessTitle: '',
      errorTitle: '',
      modalErrorDescription: '',
      privacidade: 'Privacy Policy',
      cancelamento: 'Cancellation Policy',
      copia: '',
      declaracao:
        'Bella Club declares that all models on the site were over 18 years of age on the day they were photographed. By entering this site, you swear that you are of legal age in your area to view adult material and that you wish to view it.'
    }
  }
}

export default mainfooter
